import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=78f0d5ee&"
import script from "./sidebar.vue?vue&type=script&lang=babel&"
export * from "./sidebar.vue?vue&type=script&lang=babel&"
import style0 from "./sidebar.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VList,VListItem,VListItemContent,VListItemTitle,VSelect})
